import { MarqueeContainer, MarqueeImage, MarqueeText } from './styled';

export default function GeneralItemMarquee(props) {
  const { marqueeData, clothDiaper } = props;
  return (
    <MarqueeContainer clothDiaper={clothDiaper}>
      <marquee width="100%" direction="left" loop scrollamount="4">
        {marqueeData?.map((element, index) => {
          return (
            <MarqueeText key={`marquee${index}`}>
              {element?.image ? (
                <MarqueeImage src={element?.image} alt="user image" />
              ) : null}
              {element?.text}
            </MarqueeText>
          );
        })}
      </marquee>
    </MarqueeContainer>
  );
}
